import React from 'react'
import classes from './MaxLoginForm.module.sass'
import { Button } from '../../../common/components/button/Button'

type Props = {
  setModalActive: (state: boolean) => void
}

export const MaxLoginForm = ({ setModalActive }: Props) => {
  return (
    <div className={classes.Container} onClick={(e) => e.stopPropagation()}>
      <div className={classes.Title}>MAX авторизация</div>
      <div className={classes.Description}>Здесь будет реализован новый способ входа</div>
      <div className={classes.Placeholder}>🚧 В разработке</div>
      <Button text="Закрыть" onClick={() => setModalActive(false)} timeoutMs={0} />
    </div>
  )
}
